import { generatePath } from 'react-router-dom';
import { wioApiAxiosClient } from 'libs/axios';
import { client } from '../constants/urls';
import type { Client } from './interfaces';

/** Basic client info from wio.api (name + last name), scoped by the token's company. */
export const getClientById = async (clientId: string): Promise<Client> => {
  const { data } = await wioApiAxiosClient.get<Client>(
    generatePath(client, { clientId }),
  );
  return data;
};
